import type { SelectOption } from '@/components/Select.vue';
import { CounterpartyType } from '@/entities/ledger/ledger-entry.entity';
import { computed, toValue, type MaybeRefOrGetter } from 'vue';
import { useI18n } from 'vue-i18n';

export const useCounterpartyTypeOptions = (
  types: MaybeRefOrGetter<readonly CounterpartyType[]> = Object.values(CounterpartyType),
) => {
  const { t } = useI18n({ useScope: 'global' });

  return computed<SelectOption[]>(() =>
    toValue(types).map((type) => ({
      label: t(`counterpartyTypes.${type}`),
      value: type,
    })),
  );
};
